export default "__VITE_ASSET__$JZYB04i__"